class CookiesLink extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.bndHandleClick = this.handleClick.bind(this);
    this.bndHandleKeydown = this.handleKeydown.bind(this);
    this.addEventListener('click', this.bndHandleClick);
    this.addEventListener('keydown', this.bndHandleKeydown);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.bndHandleClick);
    this.removeEventListener('keydown', this.bndHandleKeydown);
  }
  handleKeydown(event) {
    // Trigger action on Enter or Space key press for accessibility
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault(); // Prevent scrolling with space key
      this.handleClick(event);
    }
  }
  handleClick(event) {
    event.preventDefault();
    const tarteAuCitronTrigger = document.querySelector('#tarteaucitronManager');
    if (!tarteAuCitronTrigger) return;
    tarteAuCitronTrigger.click();
  }
}
customElements.define('cookies-link', CookiesLink);